export default __webpack_public_path__ + "locales/sl/MainBar.json?hash=3954b23c0e3c28865c4102d5439c800e";